export function fromLegacyFormat(legacyFormat) {
	return legacyFormat?.replace('dd', 'DD')
		.replace('EEE', 'ddd')
		.replace('E', 'ddd')
		.replace('zzz', 'ZZ')
}
